function getVideoMetadataPromise(video) {
	if (!video || video.nodeName != "VIDEO") return false;
	return new Promise((resolve) => {
		if (!video.duration) {
			video.addEventListener("loadedmetadata", (event) => {
				resolve(video);
			});
		} else {
			resolve(video);
		}
	});
}

// Carousel progressbar initialization
function avvioProgressBarInit (splide, bar) {
	var end = splide.Components.Controller.getEnd() + 1;
	var rate = Math.min((splide.index + 1) / end, 1);
	bar.style.width = String(100 * rate) + "%";
	// Toggle the Disable mode
	if (bar.style.width == '100%') {
		setTimeout(() => {
			bar.setAttribute('disabled', '');
		}, 600);
	} else {
		setTimeout(() => {
			bar.removeAttribute('disabled');
		}, 400);
	}
}
// Carousel progressbar callback on tab change and document mount
function avvioSplideProgressBar (splide, bar) {
	setTimeout(() => {
			avvioProgressBarInit(splide, bar);
	}, 600);
	splide.on("mounted move", function () {
		avvioProgressBarInit(splide, bar);
	});
}

function avvioSplideSliderInit() {
	const avvioSplideSlider = ".splide";
	let avvioSplideSliderBlock = document.querySelectorAll(avvioSplideSlider);

	if (typeof avvioSplideSliderBlock != "undefined" && avvioSplideSliderBlock != null) {
		for (var i = 0; i < avvioSplideSliderBlock.length; i++) {
			const splideElement = avvioSplideSliderBlock[i];
			let firstSlideVideo = splideElement.querySelector(".splide__slide").querySelector("video");

			function initSlider(firstSlideInterval) {
				let pagination = splideElement.querySelector(".splide__pagination");
				if (typeof pagination != "undefined" && pagination != null) {
					pagination.remove();
				}

				// SET DEFAULT OPTIONS
				var splideDefaultOptions = {
					type: "loop",
					autoplay: false,
					interval: firstSlideInterval ? parseInt(firstSlideInterval) * 1000 : 6000,
					lazyLoad: "nearby",
					pauseOnHover: false,
					resetProgress: false,
					arrows: false,
					pagination: false,
					perPage: 1,
					gap: 0,
					grid: false,
				};
				var splide = new Splide(splideElement, splideDefaultOptions);
				// splide.defaults = splideDefaultOptions;

				let bar = splide.root.querySelector(".avvio-control-bar__progress-bar");
				// Update the bar width:
				if (bar) {
					avvioSplideProgressBar(splide, bar);
				}

				// Create functionality for the custom pagination
				let customPagination = splideElement.querySelectorAll(".avvio-custom-pagination");
				if (customPagination) {
					// Update the active classes
					// Update the aria-expanded tag
					splide.on("mounted move", () => {
						const avvioSlideButton = document.querySelectorAll(".splide__pagination-button");
						for (const avvioSlideButtons of avvioSlideButton) {
							avvioSlideButtons.setAttribute("aria-expanded", "false");
							avvioSlideButtons.classList.remove("is-active-button");
							if (parseInt(avvioSlideButtons.dataset.page) === splide.index) {
								avvioSlideButtons.classList.add("is-active-button");
								avvioSlideButtons.setAttribute("aria-expanded", "true");
							}
						}
					});

					for (var list = 0; list < customPagination.length; list++) {
						let pageWrapper = customPagination[list];
						let customPaginationButtons = pageWrapper.querySelectorAll(
							".splide__pagination-button"
						);

						for (var button = 0; button < customPaginationButtons.length; button++) {
							customPaginationButtons[button].addEventListener("click", (e) => {
								let pageNumber = parseInt(e.target.dataset.page);
								splide.go(pageNumber);
							});
						}
					}
				}

				// Remove all of the clones when we update the blocks using Gutenberg, prevents issues in the admin!
				if (
					splideElement.classList.contains("is-initialized") &&
					document.body.classList.contains("wp-admin")
				) {
					// As splide-grid contains only clones due to the new structure it creates, exit out of this.
					if (splideElement.classList.contains("splide--grid")) return;
					let clones = splideElement.querySelectorAll(".splide__slide--clone");

					clones.forEach((box) => {
						box.remove();
					});
				}

				splide.on("mounted", function () {
					// Add Interval for video slides
					const videoSlide = splideElement.querySelectorAll(".splide__slide video");
					videoSlide?.forEach(function (video, index) {
						const slide = video.closest(".splide__slide");

						getVideoMetadataPromise(video)
							.then((video) => {
								slide.setAttribute("data-splide-interval", parseInt(video.duration) * 1000);
							})
							.catch((err) => {
								console.log(err);
							});
					});
				});

				// Start the carousels
				splide.mount(window.splide.Extensions);

				// Check if carousel has filters, then handle the filtering if exists
				if (
					avvioSplideSliderBlock[i] != undefined && avvioSplideSliderBlock[i] != null && typeof avvioSplideSliderBlock[i].querySelector(".js-avvio-carousel__filter") !=
					undefined &&
					avvioSplideSliderBlock[i].querySelector(".js-avvio-carousel__filter") != null
				) {
					const splideFilter = avvioSplideSliderBlock[i].querySelector(
						".js-avvio-carousel__filter"
					);
					const splideSlides = splide.Components.Slides.filter(`.splide__slide`);
					let splideList = avvioSplideSliderBlock[i].querySelector(".splide__list");

					// set active class to 'all'
					splideFilter.querySelector(".avvio-carousel__filter-item").classList.add("is-active");

					// deligate click event
					splideFilter.addEventListener("click", function (e) {
						let filterItem = e.target;

						// if not a filter item stop further execution
						if (!filterItem.classList.contains("avvio-carousel__filter-item")) {
							return;
						}

						// change active class on filter items
						splideFilter.querySelectorAll(".avvio-carousel__filter-item").forEach(function (item) {
							if (item == filterItem) {
								item.classList.add("is-active");
							} else {
								item.classList.remove("is-active");
							}
						});
						

						// empty splide list container
						splideList.innerHTML = "";

						splideSlides.forEach(function (item) {
							if (typeof (item.slide.dataset.filter) != "undefined" && item.slide.dataset.filter != null) {
								let filters = item.slide.dataset.filter.split(",");
								if (filters.includes(filterItem.dataset.filter)) {
									splideList.append(item.slide);
								}
							}
						});

						// destroy current splide instance, then remount
						splide.destroy();
						splide.mount();
						avvioSplideProgressBar(splide, bar);
					});
				}
			}

			if (typeof firstSlideVideo != "undefined" && firstSlideVideo != null) {
				getVideoMetadataPromise(firstSlideVideo)
					.then((video) => {
						initSlider(video.duration);
					})
					.catch((err) => {
						console.error(err);
					});
			} else {
				initSlider();
			}
		}
	}
} // is-initialized

/**
 * Initialize the script when the block is previewed within the editor
 * https://www.advancedcustomfields.com/resources/javascript-api/
 */
if (window.acf) {
	window.acf.addAction("render_block_preview/type=avvio-carousel", avvioSplideSliderInit);
	window.acf.addAction("render_block_preview/type=avvio-logos", avvioSplideSliderInit);
	window.acf.addAction("render_block_preview/type=avvio-testimonials", avvioSplideSliderInit);
	window.acf.addAction("render_block_preview/type=avvio-feature-panel", avvioSplideSliderInit);
	window.acf.addAction("render_block_preview/type=avvio-hero", avvioSplideSliderInit);
	window.acf.addAction("render_block_preview/type=avvio-instagram-feed", avvioSplideSliderInit);
} else {
	document.addEventListener("DOMContentLoaded", avvioSplideSliderInit);
}
